// Transforms empty string values to "null" for allowing empty string while including min length
export default function coerceNull(){return this.transform(a=>!`${a}`?.trim?.()?null:a)}